import React from 'react';

const TAG_ID = 'rafflehouse.com';

export const useIntentLyTag = () => {
  function initialize(s, m, a, r, t) {
    if (s.hasOwnProperty('$smcInstall')) return false;

    s.$smcInstall = 1;
    s[r] = s[r] || [];

    const f = m.getElementsByTagName(a)[0];
    const j = m.createElement(a);
    const dl = r !== 'dataLayer' ? '&r=' + r : '';

    j.async = true;
    j.src = '//smct.co/tm/?t=' + t + dl;

    f.parentNode.insertBefore(j, f);

    return true;
  }

  function runScript() {
    initialize(window, document, 'script', 'dataLayer', TAG_ID);
  }

  React.useEffect(() => {
    const isProduction = process.env.NODE_ENV === 'production';

    // if (isProduction) {
    runScript();
    // }
  }, []);

  return null;
};

export default useIntentLyTag;
